import { Tenant } from './tenant.model';
import { BaseEntity } from '../../xform-compat';
import { ReferenceStyle } from './reference-style';

export class Indication implements BaseEntity {
  nameSelected?: string;
  newTypeClassification?: boolean;
  id: number;
  isActuallyAReference?: boolean;
  active: boolean;
  name: string;
  synonyms: any;
  classifications: Array<{ id: string, classificationName: string }>;
  parentIndications: Array<any>;
  childIndications: Array<{ id: string, name: string }>;
  relatedIndications: Array<{ id: string, name: string }>;
  experts: Array<any>;
  upToDateLink: string;
  mapOnePager: {
    attachmentId: number,
    fileName: string,
    lastUploadedByUser: {
      userId: string,
      displayName: string
    },
    lastUploadedTimestamp: string
  };
  style: Partial<ReferenceStyle>;
  tenant: Tenant;

  constructor(data: Indication = {} as Indication) {
    this.mapOnePager = {
      attachmentId: null,
      fileName: null,
      lastUploadedByUser: {
        userId: null,
        displayName: null
      },
      lastUploadedTimestamp: null
    };
    this.id = data.id || null;
    this.name = data.name || null;
  }
}

